import React from "react";
import { Link } from "react-router-dom";
import Rating from "@material-ui/lab/Rating";

const BlogShortPosts = ({ posts }) => {
  return (
    <section className="section widget-content">
      {posts.map((posts) => (
        <div className="single-post">
          <div className="row">
            <div className="col-5">
              <img
                src={posts.imageUrl}
                className="img-fluid hoverable z-depth-1 rounded-0"
                alt={posts.title}
              />
            </div>

            <div className="col-7" style={{ overflow: "hidden" }}>
              <h6 className="my-0 font-small">
                <Link to={`/blog/post/${posts.id}`}>
                  <strong>{posts.title}</strong>
                </Link>
              </h6>

              <div className="post-data">
                <p className="font-small grey-text mb-0 font-weight-bolder">
                  <i className="far fa-clock"></i> {posts.createdDate}
                </p>
              </div>
              <Rating
                size="small"
                defaultValue={posts.ratings.value}
                precision={0.5}
                readOnly
              />
              <span
                className="font-weight-bolder"
                style={{ verticalAlign: "top" }}
              >{`${posts.ratings.value} (${posts.ratings.count})`}</span>
            </div>
          </div>
          <hr className="my-3" />
        </div>
      ))}
    </section>
  );
};

export default BlogShortPosts;
